module.exports = __webpack_public_path__ + "img/dom.bd523e03.jpg";